import { languageHelper } from "../../../config/helperFunctions";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { apiKey } from "../../../config/config";
import { toast } from "react-toastify";

export default function FeedbackForm() {
  const [formTitle, setFormTitle] = useState("");
  const [status, setStatus] = useState("active");
  const [questions, setQuestions] = useState([
    { question: "", options: ["", "", "", ""], multiOption: true },
  ]);

  useEffect(() => {
    axios
      .get(`${apiKey}/api/feedback`)
      .then((res) => {
        const data = res.data;
        setFormTitle(data.title || "");
        setStatus(data.status || "active");
        setQuestions(data.questions || [
          { question: "", options: ["", "", "", ""], multiOption: true },
        ]);
      })
      .catch(() => {
        toast.error("Error loading feedback form", { theme: "colored" });
      });
  }, []);

  const handleQuestionChange = (index, value) => {
    const updated = [...questions];
    updated[index].question = value;
    setQuestions(updated);
  };

  const handleOptionChange = (qIndex, oIndex, value) => {
    const updated = [...questions];
    updated[qIndex].options[oIndex] = value;
    setQuestions(updated);
  };

  const addQuestion = () => {
    setQuestions([
      ...questions,
      { question: "", options: ["", "", "", ""], multiOption: true },
    ]);
  };

  // const removeQuestion = (index) => {
  //   if (questions.length > 1) {
  //     setQuestions(questions.filter((_, i) => i !== index));
  //   } else {
  //     toast.warning("At least one question is required", { theme: "colored" });
  //   }
  // };

  const removeQuestion = async (index) => {
  if (questions.length <= 1) {
    toast.warning("At least one question is required", { theme: "colored" });
    return;
  }

  try {
    const res = await axios.delete(`${apiKey}/api/feedback/delete-question`, {
      data: { index },
    });

    if (res && res.data && res.data.success) {
      toast.success(res.data.message, { theme: "colored" });
      setQuestions(res.data.data || []);
    } else {
      toast.error("Unexpected response format from server", { theme: "colored" });
    }
  } catch (error) {
    console.error("Delete Error:", error);
    const msg =
      error.response?.data?.message || "Something went wrong while deleting!";
    toast.error(msg, { theme: "colored" });
  }
};

  const toggleAnswerMode = (index) => {
    const updated = [...questions];
    updated[index].multiOption = !updated[index].multiOption;
    updated[index].options = updated[index].multiOption
      ? ["", "", "", ""]
      : ["null", "null", "null", "null"];
    setQuestions(updated);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      title: formTitle,
      status,
      questions,
    };

    axios
      .post(`${apiKey}/api/feedback/store`, payload)
      .then((res) => {
        toast.success(res.data.message, { theme: "colored" });
      })
      .catch((err) => {
        const msg = err.response?.data?.message || "Something went wrong!";
        toast.error(msg, { theme: "colored" });
      });
  };
  console.log(window.location)
  // 🧷 Copy Public Feedback URL
  const copyToClipboard = () => {
    let url = window.location.origin + "/feedback";
    navigator.clipboard.writeText(url);
    toast.info("Copied: " + url, { theme: "colored" });
  };
  return (
    <main className="mx-auto my-8 p-6 bg-white rounded-xl shadow-md">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl text-[#7B20C7]">
          {languageHelper("Feedback Form")}
        </h1>
        <button
          onClick={copyToClipboard}
          type="button"
          className="flex items-center text-[#7B20C7]"
        >
          {languageHelper("Copy Link")}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
            className="ml-2 fill-[#7B20C7]"
            height="18"
            width="18"
          >
            <path d="M384 96V416c0 26.5-21.5 48-48 48H96c-26.5 
            0-48-21.5-48-48V96c0-26.5 
            21.5-48 48-48H336c26.5 0 48 21.5 48 48zM224 208H128v96h96V208zm128 0H256v96h96V208z" />
          </svg>
        </button>
      </div>

      <form onSubmit={handleSubmit}>
        {/* Title */}
        <div className="mb-4">
          <label className="block text-sm text-gray-700">{languageHelper("Form Title")}</label>
          <input
            type="text"
            value={formTitle}
            onChange={(e) => setFormTitle(e.target.value)}
            placeholder={languageHelper("Enter feedback form title")}
            className="w-full mt-1 p-2 border rounded focus:border-[#7B20C7] outline-none"
            required
          />
        </div>

        {/* Status */}
        <div className="mb-6 flex items-center gap-6">
          <label className="text-sm text-gray-700">Status:</label>
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              name="status"
              value="active"
              checked={status === "active"}
              onChange={() => setStatus("active")}
              className="text-[#7B20C7] focus:ring-[#7B20C7]"
            />
            <span className="text-green-600 font-medium">{languageHelper("Active")}</span>
          </label>
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              name="status"
              value="inactive"
              checked={status === "inactive"}
              onChange={() => setStatus("inactive")}
              className="text-[#7B20C7] focus:ring-[#7B20C7]"
            />
            <span className="text-red-500 font-medium">{languageHelper("Inactive")}</span>
          </label>
        </div>

        {/* Questions */}
        {questions.map((q, qIndex) => (
          <div
            key={qIndex}
            className="border border-gray-200 rounded-lg p-4 mb-4 bg-gray-50"
          >
            <div className="flex justify-between items-start">
              <div className="w-full">
                <label className="text-sm text-gray-700">{languageHelper("Question")}</label>
                <input
                  type="text"
                  placeholder={`Question ${qIndex + 1}`}
                  value={q.question}
                  onChange={(e) => handleQuestionChange(qIndex, e.target.value)}
                  className="w-full mt-1 p-2 border rounded focus:border-[#7B20C7] outline-none"
                  required
                />
              </div>

              {/* Delete */}
              <button
                type="button"
                onClick={() => removeQuestion(qIndex)}
                className="ml-4 mt-6 text-red-500 hover:scale-110 transition-transform"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  className="fill-red-500"
                  height="22"
                  width="22"
                >
                  <path d="M135.2 17.7L128 32H32C14.3 32 
                  0 46.3 0 64S14.3 96 32 96H416c17.7 
                  0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 
                  6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 
                  6.8-28.6 17.7zM416 128H32L53.2 
                  467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 
                  0 46.3-19.7 47.9-45L416 128z" />
                </svg>
              </button>
            </div>

            {/* Options */}
            <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-2">
              {q.multiOption ? (
                q.options.map((opt, oIndex) => (
                  <input
                    key={oIndex}
                    type="text"
                    placeholder={`Option ${oIndex + 1}`}
                    value={opt === "null" ? "" : opt}
                    onChange={(e) =>
                      handleOptionChange(qIndex, oIndex, e.target.value)
                    }
                    className="p-2 border rounded focus:border-[#7B20C7] outline-none"
                  />
                ))
              ) : (
                <input
                  type="text"
                  placeholder={languageHelper("Answer...")}
                  readOnly
                  className="w-full p-2 border rounded bg-gray-100"
                />
              )}
            </div>

            {/* Toggle */}
            <button
              type="button"
              onClick={() => toggleAnswerMode(qIndex)}
              className="mt-3 text-sm flex items-center gap-2 text-[#7B20C7]"
            >
              ⚙️{" "}
              {q.multiOption
                ? "Switch to Answer Mode"
                : "Switch to Options Mode"}
            </button>
          </div>
        ))}

        {/* Bottom Buttons */}
        <div className="mt-4 flex justify-between">
          <button
            type="button"
            onClick={addQuestion}
            className="bg-[#7B20C7] text-white py-2 px-4 rounded hover:bg-[#5B1598]"
          >
            + {languageHelper("Add Question")}
          </button>
          <button
            type="submit"
            className="bg-[#7B20C7] text-white py-2 px-4 rounded hover:bg-[#5B1598]"
          >
            {languageHelper("Save Feedback")}
          </button>
        </div>
      </form>
    </main>
  );
}
